import { defaultSelectedCustomer } from './state'

export function getDaysDebt(state,payload){
	state.customDay = payload
}


// WEBPACK FOOTER //
// ./src/modules/payment-managment/mutations.js